import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
    /*
     * Regular Stimulus lifecycle methods
     * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
     *
     * If you intend to use this controller as a regular stimulus controller as well,
     * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
     *
     * Important:
     * By default, StimulusReflex overrides the -connect- method so make sure you
     * call super if you intend to do anything else when this controller connects.
     */
    static targets = ["hm0_output"];

    connect() {
        console.log("Mission JS en cours ...");
        super.connect();
        // add your code here, if applicable

        var self = this;

        if (
            $("#partial-ressources_proposees-content").length &&
            $("#partial-ressources_proposees-content").text().search(/Chargement en cours/i) > -1
        ) {
            //on est sur le show
            setTimeout(() => this.ressources_proposees_hm_ajax(), 300);
        }

        if (
            $("#partial-bons_de_commande-content").length &&
            $("#partial-bons_de_commande-content").text().search(/Chargement en cours/i) > -1
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_hm_ajax(), 300);
        }

        if (
            $("#partial-documents-content").length &&
            $("#partial-documents-content").text().search(/Chargement en cours/i) > -1
        ) {
            //on est sur le show
            setTimeout(() => this.documents_hm_ajax(), 300);
        }

        if (
            $("#partial-livrables-content").length &&
            $("#partial-livrables-content").text().search(/Chargement en cours/i) > -1
        ) {
            //on est sur le show
            setTimeout(() => this.livrables_hm_ajax(), 300);
        }

        if (
            $("#partial-mesures_de_satisfaction-content").length &&
            $("#partial-mesures_de_satisfaction-content").text().search(/Chargement en cours/i) > -1
        ) {
            //on est sur le show
            setTimeout(() => this.mesures_de_satisfaction_hm_ajax(), 300);
        }

        if (
            $("#partial-historique-content").length &&
            $("#partial-historique-content").text().search(/Chargement en cours/i) > -1
        ) {
            //on est sur le show
            setTimeout(() => this.historique_hm_ajax(), 300);
        }

        if (
            $("#partial-versions_devis-content").length &&
            $("#partial-versions_devis-content").text().search(/Chargement en cours/i) > -1
        ) {
            //on est sur le show
            setTimeout(() => this.versions_devis_hm_ajax(), 300);
        }


        if ($("#search").length && $("#quick_sort").length) {
            //on est sur la vue list
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });
            $("#filterrific_operation_hide").click(function () {
                if ($(this).is(":checked")) {
                    $(".operation").show();
                } else {
                    $(".operation").hide();
                }
            });
            var targetElement = document.getElementById("mySidebar");
            targetElement.addEventListener("scroll", (event) => {
                var element = document.getElementById("mySidebar");
                console.log("From mission_controller.js =======> ", element.scrollTop);
                document.getElementById("scrollevel").value = element.scrollTop;
            });
        }
        $("#filterrific_with_probabilite_min").on("input", function () {
            let me = $(this)
            $("#probabilite_min").val(me.val());
        });

        function checkProbabiliteMinMax() {
            let p_min = document.getElementById('filterrific_with_probabilite_min')
            let p_max = document.getElementById('filterrific_with_probabilite_max')
            let min = Math.abs(p_min.value * 1)
            let max = Math.abs(p_max.value * 1)
            if (min >= max) {
                max = min + 1
                p_max.value = max
                document.getElementById(p_max.dataset.targetIdChange).value = max
            }
        }

        function checkMontantMinMax() {
            let p_min = document.getElementById('filterrific_with_montant_min')
            let p_max = document.getElementById('filterrific_with_montant_max')
            let min = Math.abs(p_min.value * 1)
            let max = Math.abs(p_max.value * 1)
            if (min >= max) {
                max = min + 1
                p_max.value = max
                document.getElementById(p_max.dataset.targetIdChange).value = max
            }
        }

        function updateRangeInput(me) {
            try {
                let target = me.dataset.targetIdChange
                document.getElementById(target).value = me.value
            } catch (error) {
                console.error("Null target !")
                return 1
            }
            return 0
        }

        function checkMontant(me, min, max) {
            if (me.value.length > 0) {
                if (me.value < min) {
                    me.value = min
                }
                if (me.value > max) {
                    me.value = max
                }
                if (updateRangeInput(me) === 1) {
                    return;
                }
                checkMontantMinMax()
            }
        }

        function checkProbabilite(me, min, max) {
            if (typeof min !== 'number' && typeof max !== 'number') {
                console.error('Min and max must be integer and positive !')
                return
            }

            if (me.value.length > 0) {
                if (me.value < min) {
                    me.value = min
                }
                if (me.value > max) {
                    me.value = max
                }
                if (updateRangeInput(me) === 1) {
                    return;
                }
                checkProbabiliteMinMax()
            }
        }

        try {
            document.getElementById('probabilite_min').oninput = function (e) {
                if (this.type !== 'number') {
                    console.error('Probabilite must type of number !')
                    return
                }
                checkProbabilite(this, 1, 100);
                e.stopPropagation()

            }
            document.getElementById('probabilite_max').oninput = function (e) {
                if (this.type !== 'number') {
                    console.error('Probabilite must type of number !')
                    return
                }
                checkProbabilite(this, 1, 100)
                e.stopPropagation()
            }
            document.getElementById('filterrific_with_probabilite_min').oninput = function (e) {
                checkProbabilite(this, 0, 99)
                e.stopPropagation()
            }
            document.getElementById('filterrific_with_probabilite_max').oninput = function (e) {
                checkProbabilite(this, 1, 100)
                e.stopPropagation()
            }
            document.getElementById('montant_min').oninput = function (e) {
                let max = document.getElementById('real_montant_max').value * 1
                checkMontant(this, 0, max - 1)
                e.stopPropagation()
            }
            document.getElementById('montant_max').oninput = function (e) {
                let max = document.getElementById('real_montant_max').value * 1
                checkMontant(this, 0, max)
                e.stopPropagation()
            }
            document.getElementById('filterrific_with_montant_min').oninput = function (e) {
                let max = document.getElementById('real_montant_max').value * 1
                checkMontant(this, 0, max - 1)
                e.stopPropagation()
            }
            document.getElementById('filterrific_with_montant_max').oninput = function (e) {
                let max = document.getElementById('real_montant_max').value * 1
                checkMontant(this, 1, max)
                e.stopPropagation()
            }
        } catch (error) {
            console.warn('Some ids not found ! (Possible current page is not index)')
        }
    }

    ressources_proposees_hm_ajax() {
        if (this.current_app && this.mission_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/missions/show_ajax_for_hm_ressources_proposees?mission_id=" +
                this.mission_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-ressources_proposees-content").html("");
                    $("#partial-ressources_proposees-content").html(text);
                })
            );
        }
    }

    bons_de_commande_hm_ajax() {
        if (this.current_app && this.mission_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/missions/show_ajax_for_hm_bons_de_commande?mission_id=" +
                this.mission_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-bons_de_commande-content").html("");
                    $("#partial-bons_de_commande-content").html(text);
                })
            );
        }
    }

    documents_hm_ajax() {
        if (this.current_app && this.mission_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/missions/show_ajax_for_hm_documents?mission_id=" +
                this.mission_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-documents-content").html("");
                    $("#partial-documents-content").html(text);
                })
            );
        }
    }

    livrables_hm_ajax() {
        if (this.current_app && this.mission_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/missions/show_ajax_for_hm_livrables?mission_id=" +
                this.mission_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-livrables-content").html("");
                    $("#partial-livrables-content").html(text);
                })
            );
        }
    }

    mesures_de_satisfaction_hm_ajax() {
        if (this.current_app && this.mission_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/missions/show_ajax_for_hm_mesures_de_satisfaction?mission_id=" +
                this.mission_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-mesures_de_satisfaction-content").html("");
                    $("#partial-mesures_de_satisfaction-content").html(text);
                })
            );
        }
    }

    historique_hm_ajax() {
        if (this.current_app && this.mission_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/missions/show_ajax_for_hm_historique?mission_id=" +
                this.mission_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-historique-content").html("");
                    $("#partial-historique-content").html(text);
                })
            );
        }
    }

    versions_devis_hm_ajax() {
        if (this.current_app && this.mission_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/missions/show_ajax_for_hm_versions_devis?mission_id=" +
                this.mission_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-versions_devis-content").html("");
                    $("#partial-versions_devis-content").html(text);
                })
            );
        }
    }
    get current_app() {
        return this.data.get("app");
    }

    get params() {
        return this.data.get("params");
    }

    get mission_id() {
        return this.data.get("missionid");
    }

    get url_solution() {
        return this.data.get("urlsolution");
    }
}
